import BaseQuery from "@/stateManagement/BaseQuery";
import { singleton } from "tsyringe";

import type { RewardsEarningRulesState } from "../store/RewardsEarningRulesStore";
import RewardsEarningRulesStore from "../store/RewardsEarningRulesStore";

@singleton()
class RewardsEarningRulesQuery extends BaseQuery<RewardsEarningRulesState> {
    constructor(protected store: RewardsEarningRulesStore) {
        super(store);
    }

    earningRulesList$ = this.select((state) => state.earningRulesList);
    status$ = this.select((state) => state.status);
}

export default RewardsEarningRulesQuery;
